import React from "react";
import { createElementClass, createModifierClass } from "../helpers";
export var TableCell = function TableCell(_a) {
  var align = _a.align,
      _b = _a.isHeader,
      isHeader = _b === void 0 ? false : _b,
      children = _a.children;

  var createClassName = function createClassName(type, al) {
    return createElementClass(type) + " " + createModifierClass(al, type);
  };

  return isHeader ? React.createElement("th", {
    className: createClassName("table-cell-head", align),
    align: align
  }, children) : React.createElement("td", {
    className: createClassName("table-cell", align),
    align: align
  }, children);
};